import React from 'react';
import HomeServices from "../Components/Home/HomeServices";
const AllServices = () => {
    return (
        

            <HomeServices />

        
    );
};

export default AllServices;
